import { render, staticRenderFns } from "./InboundCall.vue?vue&type=template&id=5092929c&scoped=true"
import script from "./InboundCall.vue?vue&type=script&lang=js"
export * from "./InboundCall.vue?vue&type=script&lang=js"
import style0 from "./InboundCall.vue?vue&type=style&index=0&id=5092929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092929c",
  null
  
)

export default component.exports